import React, {useEffect, useState} from 'react';
import {getLabel} from "../../../language";
import connect from "react-redux/src/components/connect";

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

const NewsItem = (props) => {
    return (
        <div className={`card${props.anonymousMode ? "-dark cw" : ""}`}>
            <div className={`card-header ${props.anonymousMode ? "bgf cw" : ""} `}>
                {getLabel(155)}
            </div>
            <div className="card-block">
                <blockquote className="card-blockquote">
                    <p>{getLabel(156)}</p>
                </blockquote>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, null)(NewsItem)
